import { FC } from 'react';

import { Avatar, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';

import AgentNote from '@/shared/types/notes/agentNote.type';

import ReplyInput from '../ReplyInput';
import Title from './components/Title';

type NoteItemProps = {
  note: AgentNote;
  isReplyItem: boolean;
  isReplyInputVisible: boolean;
  onReply: (note: string, conversationID: string) => void;
};

const NoteItem: FC<NoteItemProps> = ({
  note,
  isReplyItem,
  isReplyInputVisible,
  onReply,
}) => {
  const firstName = note.user_first_name;
  const lastName = note.user_last_name;
  const email = note.user_email_address;
  const noteContent = note.note;
  const dateCreated = note.ts_created;
  const module = note.module_ref;
  const moduleID = note.module_item_id;
  const conversationID = note.conversation_id;

  return (
    <Stack
      spacing={1}
      sx={{
        pl: isReplyItem ? 8 : 0,
        mt: isReplyItem ? 2 : 0,
      }}
    >
      <Title
        firstName={firstName}
        lastName={lastName}
        dateCreated={dateCreated}
        module={module}
        moduleID={moduleID}
      />

      <Stack direction='row' spacing={2} alignItems='center'>
        <Avatar
          alt={`${firstName} ${lastName}` || email}
          src={''}
          sx={{
            width: 48,
            height: 48,
          }}
        />

        <Box
          sx={{
            'backgroundColor': 'grey.100',
            'width': '100%',
            'borderRadius': 2,
            'p': 2,
            'position': 'relative',
            '&::before': {
              color: 'grey.100',
              content: '""',
              position: 'absolute',
              top: '50%',
              left: '-8px',
              transform: 'translateY(-50%)',
              borderWidth: '8px 8px 8px 0',
              borderStyle: 'solid',
              borderColor: 'transparent currentColor transparent transparent',
            },
          }}
        >
          <Typography variant='body2' pb={1}>
            {noteContent}
          </Typography>

          {isReplyInputVisible && (
            <ReplyInput conversationID={conversationID} onReply={onReply} />
          )}
        </Box>
      </Stack>
    </Stack>
  );
};

export default NoteItem;
